<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Damage from "./damage.vue";
import Checkout from "./checkout.vue";
import Scrap from "./scrap.vue";
import ImportTemplate from "@/views/components/common/form/devImportTemplate.vue";
import config from "@/../config";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  extends: baseList,
  components: {
    ImportTemplate,
    Damage,
    Checkout,
    Scrap,
    Image,
  },
  data() {
    return {
      table: {
        mname: "device",
        key: "id",
        url: {
          del: "/admin/system/facility",
        },
        output: false,
        order: "id",
        qrCode: "qrCode",
      },
      menus: [
        {
          label: "使用中",
          name: "deviceretrieval_list",
          auth: "system/deviceretrieval/index",
          badge: { mname: "decicestate", scene: "2" },
        },
        {
          label: "库存中",
          name: "device_list",
          auth: "system/device/index",
          badge: { mname: "decicestate", scene: "1" },
        },

        {
          label: "已损坏",
          name: "devicedamage_list",
          auth: "system/devicedamage/index",
          badge: { mname: "decicestate", scene: "3" },
        },
        {
          label: "已报废",
          name: "devicescrap_list",
          auth: "system/devicescrap/index",
          badge: { mname: "decicestate", scene: "4" },
        },
        // {
        //   label: "备用库",
        //   name: "devicestandby_list",
        //   auth: "",
        //   badge: { mname: "decicestate", scene: "5" },
        // },
        {
          label: "空码库",
          name: "Emptycode_list",
          auth: "",
          badge: { mname: "decicestate", scene: "6" },
        },
        // {
        //   label: "资产分类",
        //   name: "deviceClass_list",
        //   auth: "system/deviceClass/index",
        // },
        // { label: '入库记录', name: 'deviceRecordretrieval_list', auth: '' },
        // { label: '损坏记录', name: 'deviceRecorddamage_list', auth: '' },
        // { label: '场景管理', name: 'scene_list', auth: '' },
      ],
      query: {
        state: 5,
      },
      actions: [
        {
          label: "导出资产",
          icon: "md-download",
          type: "info",
          onClick: this.exportData.bind(this, "资产列表", 1),
          auth: "system/device/exportData",
        },
        {
          label: "批量删除",
          icon: "md-trash",
          onClick: this.batchDelete,
          auth: "system/device/batchDelete",
          type: "info",
        },
      ],
      filters: [
        {
          label: "入库时间",
          name: "createTime",
          value: "",
          type: "datetimerange",
          KeyEnter: this.search,
        },
        {
          label: "厂家",
          name: "manufacturer",
          KeyEnter: this.search,
          value: "",
          type: "input",
        },
        {
          label: "型号",
          KeyEnter: this.search,
          name: "facilityType",
          value: "",
          type: "input",
        },
        {
          label: "资产分类",
          name: "typeId",
          value: "",
          type: "select",
          KeyEnter: this.search,
          dropList: [],
        },
        // {
        //   label: "资产选择",
        //   name: "facilityNum",
        //   value: "",
        //   type: "select",
        //   KeyEnter: this.search,
        //   dropList: [],
        // },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "SN码",
          KeyEnter: this.search,
          name: "sn",
          value: "",
          type: "input",
        },
        {
          label: "资产归属",
          name: "assetOwnership",
          KeyEnter: this.search,
          value: "",
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
        {
          label: "责任人",
          KeyEnter: this.search,
          name: "liablePerson",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        // {
        //   title: "ID",
        //   key: "id",
        //   minWidth: 120,
        //   align: "left",
        // },
        {
          title: "资产编号",
          key: "assetNum",
          width: 100,
          align: "left",
          tooltip: "true",
        },
        {
          title: "型号",
          minWidth: 150,
          align: "left",
          key: "facilityType",
          tooltip: "true",
        },
        {
          title: "名称",
          key: "facilityName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        // {
        //   title: "分类",
        //   key: "typeName",
        //   minWidth: 140,
        //   align: "center",
        // },
        // {
        //   title: "IP/MAC",
        //   key: "ipMac",
        //   minWidth: 160,
        //   align: "center",
        //   copy: true,
        // },
        {
          title: "品牌",
          minWidth: 100,
          align: "left",
          key: "facilityBrand",
          tooltip: "true",
        },
        // {
        //   title: "型号",
        //   minWidth: 200,
        //   align: "center",
        //   key: "facilityType",
        // },
        // {
        //   title: "SN",
        //   minWidth: 150,
        //   align: "center",
        //   key: "sn",
        //   tooltip: true,
        // },
        // {
        //   title: "生产厂家",
        //   key: "manufacturer",
        //   width: 180,
        //   align: "center",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "span",
        //         {
        //           style: {
        //             display: "inline-block",
        //             width: "100%",
        //             overflow: "hidden",
        //             textOverflow: "ellipsis",
        //             whiteSpace: "nowrap",
        //           },
        //           domProps: {
        //             title: params.row.manufacturer,
        //           },
        //         },
        //         params.row.manufacturer
        //       ),
        //     ]);
        //   },
        // },
        // {
        //   title: "入库时间",
        //   width: 150,
        //   align: "center",
        //   key: "createTime",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.createTime.slice(0, 16);
        //     return <span>{text}</span>;
        //   },
        // },
        // {
        //   title: "资产归属",
        //   key: "assetOwnership",
        //   minWidth: 120,
        //   align: "center",
        //   tooltip: true,
        // },
        // {
        //   title: "责任人",
        //   key: "liablePerson",
        //   minWidth: 120,
        //   align: "center",
        // },
        // {
        //   title: "二维码",
        //   minWidth: 120,
        //   align: "left",
        //   key: "qrCode",
        //   viewimage: true,
        // },
        // {
        //   title: "图片",
        //   minWidth: 80,
        //   align: "center",
        //   key: "facilityImg",
        //   viewimage: true,
        // },
        {
          title: "盘点次数",
          key: "checkCount",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.checkCount == null ? 0 : row.checkCount;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "状态",
          width: 100,
          align: "center",
          key: "state",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.state == 1
                ? "库存中"
                : row.state == 2
                ? "使用中"
                : row.state == 3
                ? "已损坏"
                : row.state == 4
                ? "已报废"
                : row.state == 5
                ? "备用库"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 260,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/device/checkout" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.tocheckout(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  出库
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/device/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.handleEdit(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },

            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/device/damage" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.todamage(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  损坏
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/device/scrap" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toscrap(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  报废
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = [];
              let directives = [{ name: "auth", value: "system/device/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  记录
                </Button>
              );
            },
            "delete",

            // (vm, h, currentRow, param) => {
            //   // let directives = [];
            //   let directives = [
            //     { name: "auth", value: "system/device/record" },
            //   ];
            //   return (
            //     <Button
            //       {...{ directives }}
            //       size="small"
            //       onClick={() => this.torecord(currentRow)}
            //       type="warning"
            //       style={{ marginLeft: "5px", color: "#f2f3f5" }}
            //     >
            //       操作记录
            //     </Button>
            //   );
            // },
          ],
          auth: {
            edit: "system/device/edit",
            del: "system/device/delete",
          },
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
    // this.loadfacilityData();
  },
  methods: {
    //选中
    handleSelect(selected) {
      let ids_arr = [];
      let arry = [];
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        ids_arr.push(element[this.table.key]);
        arry.push(element[this.table.qrCode]);
      }
      this.selected = ids_arr.join(",");
      this.arrys = arry;
    },
    //批量删除
    batchDelete() {
      if (this.selected == "") {
        $utils.toast.warn("请选择需要删除的资产");
        return true;
      }
      this.$Modal.success({
        title: "确认是否要删除?",
        showOk: false,
        closable: true,
        width: "1000px",
        render: (h) => {
          return (
            <div style="width:100%;display:flex;justify-content:center; ">
              <Button
                type="primary"
                onClick={() => {
                  this.onBatchDelete();
                }}
              >
                确定
              </Button>
            </div>
          );
        },
      });
    },
    onBatchDelete() {
      let q = this.selected;
      console.log(q);
      $utils.api.load(`/admin/system/facility/batch/${q}`, "", "DELETE").then((res) => {
        if (res && res.code == 200) {
          this.$Modal.remove();
          $utils.toast.success(res.msg);
          this.search();
        }
      });
    },
    //导出标签
    downloadCodeImg() {
      if (this.arrys == null) $utils.toast.warn("请选择需要导出标签");
      // this.msg('请选择数据')
      const arry = this.arrys;
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let date = nowDate.getDate();
      var blogTitle = "资产二维码标签" + year + month + date;
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      // var arr = ['http://weixiu.kafukeji.com/admin/profile/upload/code/GK21112200028.png', ];
      // 下载后图片的文件名，个数应与arr对应
      // var imgNameList = ['图片1', '图片2', '图片3'];
      for (var i = 0; i < arry.length; i++) {
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");

        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;

          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);

          let url = canvas.toDataURL(); // 得到图片的base64编码数据
          canvas.toDataURL("image/png");

          baseList.push(url.substring(22)); // 去掉base64编码前的 data:image/png;base64,
          if (baseList.length === arry.length && baseList.length > 0) {
            for (let k = 0; k < baseList.length; k++) {
              imgs.file(
                arry[k].substring(arry[k].lastIndexOf("/") + 1, arry[k].length),
                baseList[k],
                { base64: true }
              );
            }
            zip.generateAsync({ type: "blob" }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, blogTitle + ".zip");
            });
          }
        };
        image.src = arry[i];
      }
      //如果没有跨越问题直接用图片地址
      // let arry = ['https://api.pwmqr.com/qrcode/create/?url=GK21112500039', 'https://api.pwmqr.com/qrcode/create/?url=GK21112200029'];
      // (arry.forEach(function (url, index) {
      //   setTimeout(() => {//setTimeout是为了防止arry太多导致下载终端机
      //     let link = document.createElement('a')
      //     // 这里是将url转成blob地址，
      //     fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
      //       link.href = URL.createObjectURL(blob)
      //       let temp = url.split("?");
      //       temp = temp[0].split("/");
      //       let name = temp[temp.length - 1];//获得图片名字
      //       link.download = name;
      //       document.body.appendChild(link);
      //       link.click()
      //     })
      //   }, index * 1000)//1000是为了使得浏览器能稳定下载  这个时间可自调建议大于500
      // }))
    },
    //同步二维码
    // torefall() {
    //   if (this.selected == "") {
    //     $utils.toast.warn("请选择需要同步二维码的资产");
    //     return true;
    //   }
    //   this.id = this.selected
    //   this.sloading = true;
    //   $utils.api
    //     .load(`/admin/system/facility/refreshBatch/${this.id}`,"","GET")
    //     .then((res) => {
    //       this.sloading = false;
    //       if (res.status) {
    //         $utils.toast.success(res.msg);
    //         if (res.msg) {
    //           setTimeout(() => {
    //             $utils.url.go(0);
    //           }, 500);
    //         }
    //       }
    //     })
    //     .catch((e) => {
    //       this.sloading = false;
    //       $utils.toast.error("保存异常" + e.message);
    //     });
    // },
    // //同步
    // toref(currentRow) {
    //   this.id = currentRow.id;
    //   this.sloading = true;
    //   $utils.api
    //     .load(`/admin/system/facility/refresh/${this.id}`)
    //     .then((res) => {
    //       this.sloading = false;
    //       if (res.status) {
    //         $utils.toast.success("同步成功");
    //         setTimeout(() => {
    //           $utils.url.go(0);
    //         }, 300);
    //       }
    //     })
    //     .catch((e) => {
    //       this.sloading = false;
    //       $utils.toast.error("保存异常" + e.message);
    //     });
    // },
    todamage(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "损坏",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Damage
              style={{ margin: "0", color: "#19be6b" }}
              facilityId={row.id}
              createBy={row.createBy}
              onReset={() => {
                  this.search();
                }}
            ></Damage>
          );
        },
      });
    },
    tocheckout(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "出库",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Checkout
              style={{ margin: "0", color: "#19be6b" }}
              facilityId={row.id}
              createBy={row.createBy}
              onReset={() => {
                  this.search();
                }}
            ></Checkout>
          );
        },
      });
    },
    toscrap(row) {
      this.facilityId = row.id;
      this.$Modal.success({
        closable: true,
        title: "报废",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Scrap
              style={{ margin: "0", color: "#19be6b" }}
              facilityId={row.id}
              createBy={row.createBy}
              onReset={() => {
                  this.search();
                }}
            ></Scrap>
          );
        },
      });
    },
    loadfacilityData() {
      // 通过pk查询字典数据
      let q = {};
      q.state = 5;
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "facilityNum") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/facilityType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
            // console.log("dropList typeId", dropList);
          }
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "device_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "device_edit",
        query: { action: "view", kv: currentRow.id },
      });
    },
    //转单
    toChange(row) {},
    //记录
    toInfo(row) {
      $utils.url.push({
        name: "deviceRecordIndex",
        query: { facilityId: row.id, facilityNo: row.facilityNum },
      });
    },
    //操作记录
    torecord(row) {
      $utils.url.push({
        name: "deviceRecordIndex",
        query: { facilityId: row.id },
      });
    },

    //导入
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            ></ImportTemplate>
          );
        },
      });
    },
    //下载模板
    toDownload() {
      window.location.href = config.API_HOST + `/admin/system/facility/template/download`;
    },
  },
};
</script>
<style scoped></style>
